"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePaymentReasonPanel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../commonFunctions");
var services_1 = require("@falcon/services");
var BasePaymentReasonPanel = /** @class */ (function (_super) {
    __extends(BasePaymentReasonPanel, _super);
    function BasePaymentReasonPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.amountToDisplay = function () {
            var displayMessage;
            if (_this.props.interaction.factors.additionalPremium > 0) {
                displayMessage = (0, jsx_runtime_1.jsx)("div", { className: "payment-reason-price", id: "price", children: (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.additionalPremium) });
            }
            else if (_this.props.interaction.factors.returnPremium > 0) {
                displayMessage = (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("p", { children: "Refund of " }), (0, jsx_runtime_1.jsx)("span", { className: "payment-reason-price", id: "price", children: (0, commonFunctions_1.getAmountToDisplay)(_this.props.interaction.factors.returnPremium) })] });
            }
            else {
                displayMessage = (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("b", { children: "There's no extra cost" }) });
            }
            return displayMessage;
        };
        return _this;
    }
    BasePaymentReasonPanel.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies().subscribe(function (policies) {
            var filteredPolicies = policies.filter(function (policy) { return !policy.products.includes(services_1.ProductsEnum.WOLF_MOTOR); });
            _this.setState({
                policies: filteredPolicies,
                policiesLoaded: true
            });
        });
        this.customerPortalService.getProfile().subscribe(function (output) {
            _this.setState({
                party: output,
                partyLoaded: true
            });
        });
        this.customerPortalService.getSubscription().subscribe(function (subscription) {
            _this.setState({
                subscription: subscription,
                subscriptionLoaded: true
            });
        });
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], BasePaymentReasonPanel.prototype, "customerPortalService", void 0);
    BasePaymentReasonPanel = __decorate([
        components_1.authorize
    ], BasePaymentReasonPanel);
    return BasePaymentReasonPanel;
}(plugin_journey_1.WidgetBase));
exports.BasePaymentReasonPanel = BasePaymentReasonPanel;
//# sourceMappingURL=BasePaymentReasonPanel.js.map